import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemingService } from 'src/app/theming.service';
import { SettingsService } from 'src/app/settings.service';
import { LambdaService } from 'src/app/lambda.service';
import { Router } from '@angular/router';
import { TimekitTabsComponent } from '../timekit-tabs/timekit-tabs.component';
import { ApiService } from 'src/app/api.service';
import { ChangeDetectorRef } from '@angular/core';

declare var $: any;

interface Project {
  projectId: string;
  projectName: string;
  externalId: string;
  timekitProjectId: number;
}

@Component({
  selector: 'app-timekit-projects',
  templateUrl: './timekit-projects.component.html',
  styleUrls: ['./timekit-projects.component.scss']
})

export class TimekitProjectsComponent implements OnInit {
  @Input() data: any;
  @Output() edit = new EventEmitter<string>();
  projects: Project[] = [];
  loading: boolean = false;
  showNoProjectsMessage: boolean = false;
  externalId: string = '';
  timekitProjectId: number = 0;
  @Input() goBackCallback!: () => void

  constructor(
    public themingService: ThemingService,
    private settingsService: SettingsService,
    private lambdaService: LambdaService,
    private router: Router,
    private tabsParent: TimekitTabsComponent,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.getTimekitProjects()
    this.settingsService.getListingProjects$().subscribe((active) => {
      if (active) {
        this.getTimekitProjects();
      }
    });
  }

  async getTimekitProjects() {
    this.loading = true;
    this.showNoProjectsMessage = false;

    try {
      const response = await this.lambdaService.getTimekitProjects(this.themingService.shopId) as { data: Project[] };

      this.projects = response.data || [];
    } catch (error) {
      console.error('Error al obtener proyectos:', error);
      this.projects = [];
    } finally {
      this.loading = false;
    }
  }

  editProject(externalId: string) {
    this.tabsParent.setCreateProjectTab(externalId);
  }

  setCreatingProjects() {
    this.settingsService.setCreatingProjects();
  }

  deleteProject(projectId: string, timekitProjectId: number) {
    this.apiService.deleteTimekitProject(projectId, timekitProjectId, this.themingService.shopId)
      .then(() => {
        this.getTimekitProjects();

        $('#successDeleteProjectModal').modal('show');
        $('#successDeleteProjectModal').on('hidden.bs.modal', () => { });
      })
      .catch(error => {
        console.error('Error al eliminar el proyecto:', error);
        this.showErrorModal();
      });
  }

  showErrorModal(): void {
    $('#errorDeleteProjectModal').modal('show');
    $('#errorDeleteProjectModal').on('hidden.bs.modal', () => {
    });
  }

  closeModal() {
    $('#requiredProjectModal').modal('hide');
    $('#errorDeleteProjectModal').modal('hide');
  }

  closeSuccessModal() {
    $('#successDeleteProjectModal').modal('hide');
  }
}
